// @generated by protoc-gen-es v2.0.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/uploads/v2/types.proto (package creativefabrica.uploads.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/uploads/v2/types.proto.
 */
export const file_creativefabrica_uploads_v2_types: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * InputDetails represents the source video information
 *
 * @generated from message creativefabrica.uploads.v2.InputDetails
 */
export type InputDetails = Message<"creativefabrica.uploads.v2.InputDetails"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.VideoStream video = 2;
   */
  video: VideoStream[];
};

/**
 * JSON type for the message creativefabrica.uploads.v2.InputDetails.
 */
export type InputDetailsJson = {
  /**
   * @generated from field: int32 id = 1;
   */
  id?: number;

  /**
   * @generated from field: repeated creativefabrica.uploads.v2.VideoStream video = 2;
   */
  video?: VideoStreamJson[];
};

/**
 * Describes the message creativefabrica.uploads.v2.InputDetails.
 * Use `create(InputDetailsSchema)` to create a new message.
 */
export const InputDetailsSchema: GenMessage<InputDetails, InputDetailsJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_types, 0);

/**
 * VideoStream represents a single video stream
 *
 * @generated from message creativefabrica.uploads.v2.VideoStream
 */
export type VideoStream = Message<"creativefabrica.uploads.v2.VideoStream"> & {
  /**
   * @generated from field: int32 bit_depth = 1;
   */
  bitDepth: number;

  /**
   * @generated from field: string codec = 2;
   */
  codec: string;

  /**
   * @generated from field: string color_format = 3;
   */
  colorFormat: string;

  /**
   * @generated from field: string four_cc = 4;
   */
  fourCc: string;

  /**
   * @generated from field: int32 frame_rate = 5;
   */
  frameRate: number;

  /**
   * @generated from field: int32 height = 6;
   */
  height: number;

  /**
   * @generated from field: string interlace_mode = 7;
   */
  interlaceMode: string;

  /**
   * @generated from field: string sar = 8;
   */
  sar: string;

  /**
   * @generated from field: string standard = 9;
   */
  standard: string;

  /**
   * @generated from field: int32 stream_id = 10;
   */
  streamId: number;

  /**
   * @generated from field: int32 width = 11;
   */
  width: number;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.VideoStream.
 */
export type VideoStreamJson = {
  /**
   * @generated from field: int32 bit_depth = 1;
   */
  bitDepth?: number;

  /**
   * @generated from field: string codec = 2;
   */
  codec?: string;

  /**
   * @generated from field: string color_format = 3;
   */
  colorFormat?: string;

  /**
   * @generated from field: string four_cc = 4;
   */
  fourCc?: string;

  /**
   * @generated from field: int32 frame_rate = 5;
   */
  frameRate?: number;

  /**
   * @generated from field: int32 height = 6;
   */
  height?: number;

  /**
   * @generated from field: string interlace_mode = 7;
   */
  interlaceMode?: string;

  /**
   * @generated from field: string sar = 8;
   */
  sar?: string;

  /**
   * @generated from field: string standard = 9;
   */
  standard?: string;

  /**
   * @generated from field: int32 stream_id = 10;
   */
  streamId?: number;

  /**
   * @generated from field: int32 width = 11;
   */
  width?: number;
};

/**
 * Describes the message creativefabrica.uploads.v2.VideoStream.
 * Use `create(VideoStreamSchema)` to create a new message.
 */
export const VideoStreamSchema: GenMessage<VideoStream, VideoStreamJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_types, 1);

/**
 * OutputGroupDetail represents a group of output files
 *
 * @generated from message creativefabrica.uploads.v2.OutputGroupDetail
 */
export type OutputGroupDetail = Message<"creativefabrica.uploads.v2.OutputGroupDetail"> & {
  /**
   * @generated from field: repeated creativefabrica.uploads.v2.OutputDetail output_details = 1;
   */
  outputDetails: OutputDetail[];

  /**
   * @generated from field: repeated string playlist_file_paths = 2;
   */
  playlistFilePaths: string[];

  /**
   * @generated from field: string type = 3;
   */
  type: string;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.OutputGroupDetail.
 */
export type OutputGroupDetailJson = {
  /**
   * @generated from field: repeated creativefabrica.uploads.v2.OutputDetail output_details = 1;
   */
  outputDetails?: OutputDetailJson[];

  /**
   * @generated from field: repeated string playlist_file_paths = 2;
   */
  playlistFilePaths?: string[];

  /**
   * @generated from field: string type = 3;
   */
  type?: string;
};

/**
 * Describes the message creativefabrica.uploads.v2.OutputGroupDetail.
 * Use `create(OutputGroupDetailSchema)` to create a new message.
 */
export const OutputGroupDetailSchema: GenMessage<OutputGroupDetail, OutputGroupDetailJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_types, 2);

/**
 * OutputDetail represents a single output file
 *
 * @generated from message creativefabrica.uploads.v2.OutputDetail
 */
export type OutputDetail = Message<"creativefabrica.uploads.v2.OutputDetail"> & {
  /**
   * @generated from field: repeated string output_file_paths = 1;
   */
  outputFilePaths: string[];

  /**
   * @generated from field: int64 duration_in_ms = 2;
   */
  durationInMs: bigint;

  /**
   * @generated from field: creativefabrica.uploads.v2.VideoDetails video_details = 3;
   */
  videoDetails?: VideoDetails;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.OutputDetail.
 */
export type OutputDetailJson = {
  /**
   * @generated from field: repeated string output_file_paths = 1;
   */
  outputFilePaths?: string[];

  /**
   * @generated from field: int64 duration_in_ms = 2;
   */
  durationInMs?: string;

  /**
   * @generated from field: creativefabrica.uploads.v2.VideoDetails video_details = 3;
   */
  videoDetails?: VideoDetailsJson;
};

/**
 * Describes the message creativefabrica.uploads.v2.OutputDetail.
 * Use `create(OutputDetailSchema)` to create a new message.
 */
export const OutputDetailSchema: GenMessage<OutputDetail, OutputDetailJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_types, 3);

/**
 * VideoDetails represents video properties for an output
 *
 * @generated from message creativefabrica.uploads.v2.VideoDetails
 */
export type VideoDetails = Message<"creativefabrica.uploads.v2.VideoDetails"> & {
  /**
   * @generated from field: int32 width_in_px = 1;
   */
  widthInPx: number;

  /**
   * @generated from field: int32 height_in_px = 2;
   */
  heightInPx: number;

  /**
   * @generated from field: int32 average_bitrate = 3;
   */
  averageBitrate: number;

  /**
   * @generated from field: double qvbr_avg_quality = 4;
   */
  qvbrAvgQuality: number;

  /**
   * @generated from field: double qvbr_min_quality = 5;
   */
  qvbrMinQuality: number;

  /**
   * @generated from field: double qvbr_max_quality = 6;
   */
  qvbrMaxQuality: number;

  /**
   * @generated from field: int32 qvbr_min_quality_location = 7;
   */
  qvbrMinQualityLocation: number;

  /**
   * @generated from field: int32 qvbr_max_quality_location = 8;
   */
  qvbrMaxQualityLocation: number;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.VideoDetails.
 */
export type VideoDetailsJson = {
  /**
   * @generated from field: int32 width_in_px = 1;
   */
  widthInPx?: number;

  /**
   * @generated from field: int32 height_in_px = 2;
   */
  heightInPx?: number;

  /**
   * @generated from field: int32 average_bitrate = 3;
   */
  averageBitrate?: number;

  /**
   * @generated from field: double qvbr_avg_quality = 4;
   */
  qvbrAvgQuality?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double qvbr_min_quality = 5;
   */
  qvbrMinQuality?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double qvbr_max_quality = 6;
   */
  qvbrMaxQuality?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int32 qvbr_min_quality_location = 7;
   */
  qvbrMinQualityLocation?: number;

  /**
   * @generated from field: int32 qvbr_max_quality_location = 8;
   */
  qvbrMaxQualityLocation?: number;
};

/**
 * Describes the message creativefabrica.uploads.v2.VideoDetails.
 * Use `create(VideoDetailsSchema)` to create a new message.
 */
export const VideoDetailsSchema: GenMessage<VideoDetails, VideoDetailsJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_types, 4);

/**
 * Outputs represents the CDN URLs for different output types
 *
 * @generated from message creativefabrica.uploads.v2.Outputs
 */
export type Outputs = Message<"creativefabrica.uploads.v2.Outputs"> & {
  /**
   * @generated from field: repeated string hls_group = 1;
   */
  hlsGroup: string[];

  /**
   * @generated from field: repeated string dash_group = 2;
   */
  dashGroup: string[];

  /**
   * @generated from field: repeated string file_group = 3;
   */
  fileGroup: string[];

  /**
   * @generated from field: repeated string thumbnail_group = 4;
   */
  thumbnailGroup: string[];

  /**
   * @generated from field: repeated string preview_group = 5;
   */
  previewGroup: string[];

  /**
   * @generated from field: repeated string frame_capture_group = 6;
   */
  frameCaptureGroup: string[];
};

/**
 * JSON type for the message creativefabrica.uploads.v2.Outputs.
 */
export type OutputsJson = {
  /**
   * @generated from field: repeated string hls_group = 1;
   */
  hlsGroup?: string[];

  /**
   * @generated from field: repeated string dash_group = 2;
   */
  dashGroup?: string[];

  /**
   * @generated from field: repeated string file_group = 3;
   */
  fileGroup?: string[];

  /**
   * @generated from field: repeated string thumbnail_group = 4;
   */
  thumbnailGroup?: string[];

  /**
   * @generated from field: repeated string preview_group = 5;
   */
  previewGroup?: string[];

  /**
   * @generated from field: repeated string frame_capture_group = 6;
   */
  frameCaptureGroup?: string[];
};

/**
 * Describes the message creativefabrica.uploads.v2.Outputs.
 * Use `create(OutputsSchema)` to create a new message.
 */
export const OutputsSchema: GenMessage<Outputs, OutputsJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_types, 5);

/**
 * S3Metadata represents S3 object metadata
 *
 * @generated from message creativefabrica.uploads.v2.S3Metadata
 */
export type S3Metadata = Message<"creativefabrica.uploads.v2.S3Metadata"> & {
  /**
   * @generated from field: int64 size = 1;
   */
  size: bigint;

  /**
   * @generated from field: string etag = 2;
   */
  etag: string;

  /**
   * @generated from field: string sequencer = 3;
   */
  sequencer: string;

  /**
   * @generated from field: string content_type = 4;
   */
  contentType: string;

  /**
   * @generated from field: string last_modified = 5;
   */
  lastModified: string;
};

/**
 * JSON type for the message creativefabrica.uploads.v2.S3Metadata.
 */
export type S3MetadataJson = {
  /**
   * @generated from field: int64 size = 1;
   */
  size?: string;

  /**
   * @generated from field: string etag = 2;
   */
  etag?: string;

  /**
   * @generated from field: string sequencer = 3;
   */
  sequencer?: string;

  /**
   * @generated from field: string content_type = 4;
   */
  contentType?: string;

  /**
   * @generated from field: string last_modified = 5;
   */
  lastModified?: string;
};

/**
 * Describes the message creativefabrica.uploads.v2.S3Metadata.
 * Use `create(S3MetadataSchema)` to create a new message.
 */
export const S3MetadataSchema: GenMessage<S3Metadata, S3MetadataJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_uploads_v2_types, 6);

/**
 * @generated from enum creativefabrica.uploads.v2.UploadApp
 */
export enum UploadApp {
  /**
   * @generated from enum value: UPLOAD_APP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPLOAD_APP_VECTORIZER = 1;
   */
  VECTORIZER = 1,

  /**
   * @generated from enum value: UPLOAD_APP_STUDIO = 2;
   */
  STUDIO = 2,

  /**
   * @generated from enum value: UPLOAD_APP_SPARK = 3;
   */
  SPARK = 3,

  /**
   * @generated from enum value: UPLOAD_APP_SPARK_BACKGROUND_REMOVER = 4;
   */
  SPARK_BACKGROUND_REMOVER = 4,

  /**
   * @generated from enum value: UPLOAD_APP_ADVERTISING = 5;
   */
  ADVERTISING = 5,

  /**
   * @generated from enum value: UPLOAD_APP_STUDIO_FONT = 6;
   */
  STUDIO_FONT = 6,

  /**
   * @generated from enum value: UPLOAD_APP_DESIGN_REVIEWER = 7;
   */
  DESIGN_REVIEWER = 7,

  /**
   * @generated from enum value: UPLOAD_APP_ASKCF = 8;
   */
  ASKCF = 8,

  /**
   * @generated from enum value: UPLOAD_APP_SOCIAL = 9;
   */
  SOCIAL = 9,

  /**
   * @generated from enum value: UPLOAD_APP_PUBLISHER = 10;
   */
  PUBLISHER = 10,

  /**
   * @generated from enum value: UPLOAD_APP_CLUBHOUSES = 11;
   */
  CLUBHOUSES = 11,

  /**
   * @generated from enum value: UPLOAD_APP_UPSCALER = 12;
   */
  UPSCALER = 12,

  /**
   * @generated from enum value: UPLOAD_APP_CLUBHOUSES_ADMIN = 13;
   */
  CLUBHOUSES_ADMIN = 13,

  /**
   * @generated from enum value: UPLOAD_APP_CONVERTER = 14;
   */
  CONVERTER = 14,

  /**
   * @generated from enum value: UPLOAD_APP_STUDIO_IMAGE_PROCESSOR = 15;
   */
  STUDIO_IMAGE_PROCESSOR = 15,

  /**
   * @generated from enum value: UPLOAD_APP_STUDIO_MEDIA_MATRIX = 16;
   */
  STUDIO_MEDIA_MATRIX = 16,

  /**
   * @generated from enum value: UPLOAD_APP_STUDIO_MODALITY = 17;
   */
  STUDIO_MODALITY = 17,

  /**
   * @generated from enum value: UPLOAD_APP_CHARACTERS = 18;
   */
  CHARACTERS = 18,

  /**
   * @generated from enum value: UPLOAD_APP_WORDPRESS_PRODUCT_FILES = 19;
   */
  WORDPRESS_PRODUCT_FILES = 19,

  /**
   * @generated from enum value: UPLOAD_APP_WORDPRESS_PRODUCT_IMAGES = 20;
   */
  WORDPRESS_PRODUCT_IMAGES = 20,
}

/**
 * JSON type for the enum creativefabrica.uploads.v2.UploadApp.
 */
export type UploadAppJson = "UPLOAD_APP_UNSPECIFIED" | "UPLOAD_APP_VECTORIZER" | "UPLOAD_APP_STUDIO" | "UPLOAD_APP_SPARK" | "UPLOAD_APP_SPARK_BACKGROUND_REMOVER" | "UPLOAD_APP_ADVERTISING" | "UPLOAD_APP_STUDIO_FONT" | "UPLOAD_APP_DESIGN_REVIEWER" | "UPLOAD_APP_ASKCF" | "UPLOAD_APP_SOCIAL" | "UPLOAD_APP_PUBLISHER" | "UPLOAD_APP_CLUBHOUSES" | "UPLOAD_APP_UPSCALER" | "UPLOAD_APP_CLUBHOUSES_ADMIN" | "UPLOAD_APP_CONVERTER" | "UPLOAD_APP_STUDIO_IMAGE_PROCESSOR" | "UPLOAD_APP_STUDIO_MEDIA_MATRIX" | "UPLOAD_APP_STUDIO_MODALITY" | "UPLOAD_APP_CHARACTERS" | "UPLOAD_APP_WORDPRESS_PRODUCT_FILES" | "UPLOAD_APP_WORDPRESS_PRODUCT_IMAGES";

/**
 * Describes the enum creativefabrica.uploads.v2.UploadApp.
 */
export const UploadAppSchema: GenEnum<UploadApp, UploadAppJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_uploads_v2_types, 0);

/**
 * @generated from enum creativefabrica.uploads.v2.UploadState
 */
export enum UploadState {
  /**
   * @generated from enum value: UPLOAD_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPLOAD_STATE_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: UPLOAD_STATE_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: UPLOAD_STATE_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * JSON type for the enum creativefabrica.uploads.v2.UploadState.
 */
export type UploadStateJson = "UPLOAD_STATE_UNSPECIFIED" | "UPLOAD_STATE_CREATED" | "UPLOAD_STATE_COMPLETED" | "UPLOAD_STATE_FAILED";

/**
 * Describes the enum creativefabrica.uploads.v2.UploadState.
 */
export const UploadStateSchema: GenEnum<UploadState, UploadStateJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_uploads_v2_types, 1);

